enum DragDataTypes {
  Moment = 'moment',
  Content = 'content',
}

type MomentDragData = {
  daySegment: string
  id: string
  scheduledAt: string
  type: DragDataTypes.Moment
}

export type ContentDragData = {
  contentId: string
  contentPosition: number
  momentId: string
  type: DragDataTypes.Content
}

export const setContentDragData = (
  event: React.DragEvent,
  data: Omit<ContentDragData, 'type'>
): void => {
  const serializedData = JSON.stringify({
    ...data,
    type: DragDataTypes.Content,
  })
  event.dataTransfer.setData('text', serializedData)
}

export const setMomentDragData = (
  event: React.DragEvent,
  data: Omit<MomentDragData, 'type'>
): void => {
  const serializedData = JSON.stringify({ ...data, type: DragDataTypes.Moment })
  event.dataTransfer.setData('text', serializedData)
}

export const getContentDragData = (
  event: React.DragEvent
): ContentDragData | null => {
  const serializedData = event.dataTransfer.getData('text')
  if (serializedData === '') return null

  try {
    const data: unknown = JSON.parse(serializedData)
    return isContentData(data) ? data : null
  } catch {
    console.error('Error: Content Drag Data unable to be retrieved.')
    return null
  }
}

export const getMomentDragData = (
  event: React.DragEvent
): MomentDragData | null => {
  const serializedData = event.dataTransfer.getData('text')
  if (serializedData === '') return null

  try {
    const data: unknown = JSON.parse(serializedData)
    return isMomentData(data) ? data : null
  } catch {
    console.error('Error: Moment Drag Data unable to be retrieved.')
    return null
  }
}

function isContentData(data: unknown): data is ContentDragData {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as ContentDragData)?.type === DragDataTypes.Content &&
    typeof (data as ContentDragData)?.contentId === 'string'
  )
}

function isMomentData(data: unknown): data is MomentDragData {
  return (
    typeof data === 'object' &&
    data !== null &&
    (data as MomentDragData)?.type === DragDataTypes.Moment &&
    typeof (data as MomentDragData)?.id === 'string'
  )
}
